// @ts-nocheck
export const TIPO_ATRASO_CRITICO = 'DESCARGA_ATRASO_CRITICO';
export const TIPO_ESPERA_ELEVADA = 'DESCARGA_ESPERA_ELEVADA';
export const SOM_ATRASO_MP3_PATH = '/sons/universfield-new-notification-09-352705.mp3';
const STORAGE_ALERTA_ATIVO = 'notificacoes-alerta-ativo';
const obterEnvAlertaSonoro = () => {
    const valor = process.env.REACT_APP_NOTIFICACOES_ALERTA_SONORO;
    if (valor === undefined || valor === null || valor === '') {
        return true;
    }
    return valor === 'true';
};
export const alertasAtivosNoStorage = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.localStorage.getItem(STORAGE_ALERTA_ATIVO) === 'true';
};
export const persistirAlertasAtivos = () => {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.setItem(STORAGE_ALERTA_ATIVO, 'true');
};
export const desativarAlertasNoStorage = () => {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.removeItem(STORAGE_ALERTA_ATIVO);
};
const normalizarDadosAdicionais = (notificacao) => {
    const dados = notificacao?.DadosAdicionais;
    if (!dados) {
        return null;
    }
    if (typeof dados === 'string') {
        try {
            return JSON.parse(dados);
        }
        catch {
            return null;
        }
    }
    return dados;
};
export const extrairLoja = (notificacao) => {
    const dados = normalizarDadosAdicionais(notificacao);
    if (dados?.loja) {
        return String(dados.loja).trim();
    }
    const titulo = notificacao?.Titulo || '';
    const match = titulo.match(/Loja\s+(\S+)/i);
    if (match?.[1]) {
        return match[1].trim();
    }
    return 'desconhecida';
};
export const montarFraseVoz = (loja, tipoNotificacao) => {
    if (tipoNotificacao === TIPO_ESPERA_ELEVADA) {
        return `Espera elevada descarga loja ${loja}`;
    }
    return `Atraso descarga loja ${loja}`;
};
export const ehNotificacaoAtrasoCritico = (notificacao) => {
    return notificacao?.TipoNotificacao === TIPO_ATRASO_CRITICO;
};
export const ehNotificacaoEsperaElevada = (notificacao) => {
    return notificacao?.TipoNotificacao === TIPO_ESPERA_ELEVADA;
};
export const ehNotificacaoAlertaDescarga = (notificacao) => {
    return ehNotificacaoAtrasoCritico(notificacao) || ehNotificacaoEsperaElevada(notificacao);
};
export const prioridadeNotificacao = (notificacao) => {
    const tipo = notificacao?.TipoNotificacao;
    if (tipo === TIPO_ATRASO_CRITICO) {
        return 0;
    }
    if (tipo === TIPO_ESPERA_ELEVADA) {
        return 1;
    }
    return 2;
};
export const ordenarNotificacoesListagem = (registros) => {
    if (!Array.isArray(registros)) {
        return [];
    }
    return [...registros].sort((a, b) => {
        const diffPrioridade = prioridadeNotificacao(a) - prioridadeNotificacao(b);
        if (diffPrioridade !== 0) {
            return diffPrioridade;
        }
        const dataA = new Date(a?.DataCriacao || 0).getTime();
        const dataB = new Date(b?.DataCriacao || 0).getTime();
        return dataB - dataA;
    });
};
export const deveAlertar = (notificacao) => {
    if (!ehNotificacaoAlertaDescarga(notificacao)) {
        return false;
    }
    if (!obterEnvAlertaSonoro()) {
        return false;
    }
    return alertasAtivosNoStorage();
};
const tocarSomMp3 = (caminho) => {
    return new Promise((resolve, reject) => {
        if (typeof window === 'undefined') {
            reject(new Error('Ambiente sem window'));
            return;
        }
        const audio = new Audio(caminho);
        audio.volume = 0.85;
        audio.onended = () => resolve();
        audio.onerror = () => reject(new Error('Falha ao reproduzir MP3'));
        audio.play().catch((erro) => reject(erro));
    });
};
const obterVozPtBr = (vozes) => {
    if (!Array.isArray(vozes) || vozes.length === 0) {
        return null;
    }
    return (vozes.find((voz) => voz.lang && voz.lang.toLowerCase() === 'pt-br') ||
        vozes.find((voz) => voz.lang && voz.lang.toLowerCase().startsWith('pt')) ||
        null);
};
export const prepararSinteseVoz = () => {
    return new Promise((resolve) => {
        if (typeof window === 'undefined' || !window.speechSynthesis) {
            resolve([]);
            return;
        }
        const sintese = window.speechSynthesis;
        const obterVozes = () => sintese.getVoices().filter((voz) => voz.lang);
        const finalizar = () => {
            sintese.removeEventListener('voiceschanged', aoCarregarVozes);
            resolve(obterVozes());
        };
        const aoCarregarVozes = () => {
            if (obterVozes().length > 0) {
                finalizar();
            }
        };
        if (obterVozes().length > 0) {
            resolve(obterVozes());
            return;
        }
        sintese.addEventListener('voiceschanged', aoCarregarVozes);
        sintese.getVoices();
        window.setTimeout(finalizar, 1200);
    });
};
export const falarMensagem = async (texto) => {
    if (typeof window === 'undefined' || !window.speechSynthesis) {
        return;
    }
    const sintese = window.speechSynthesis;
    const vozes = await prepararSinteseVoz();
    sintese.cancel();
    sintese.resume();
    await new Promise((resolve) => {
        const utterance = new SpeechSynthesisUtterance(texto);
        utterance.lang = 'pt-BR';
        utterance.rate = 0.95;
        utterance.pitch = 1;
        utterance.volume = 1;
        const voz = obterVozPtBr(vozes);
        if (voz) {
            utterance.voice = voz;
        }
        utterance.onend = () => resolve();
        utterance.onerror = () => resolve();
        sintese.speak(utterance);
        // Workaround Chrome: síntese pode ficar pausada até resume explícito.
        window.setTimeout(() => {
            if (sintese.speaking && sintese.paused) {
                sintese.resume();
            }
        }, 150);
    });
};
export const alertarAtrasoDescarga = async (notificacao) => {
    const loja = extrairLoja(notificacao);
    const frase = montarFraseVoz(loja, notificacao?.TipoNotificacao);
    try {
        await tocarSomMp3(SOM_ATRASO_MP3_PATH);
    }
    catch {
        // fallback: apenas voz
    }
    await falarMensagem(frase);
};
export const solicitarPermissaoNotificacaoSO = async () => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return 'denied';
    }
    if (Notification.permission === 'granted') {
        return 'granted';
    }
    if (Notification.permission === 'denied') {
        return 'denied';
    }
    return Notification.requestPermission();
};
export const exibirNotificacaoSO = (notificacao, aoClicar) => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return null;
    }
    if (Notification.permission !== 'granted') {
        return null;
    }
    const tituloPadrao = ehNotificacaoEsperaElevada(notificacao)
        ? 'Espera elevada na descarga'
        : 'Atraso na descarga';
    const notificacaoSO = new Notification(notificacao.Titulo || tituloPadrao, {
        body: notificacao.Mensagem || '',
        icon: `${window.location.origin}/favicon.ico`,
        tag: `descarga-alerta-${notificacao.Id}`,
    });
    notificacaoSO.onclick = () => {
        window.focus();
        if (aoClicar) {
            aoClicar();
        }
        notificacaoSO.close();
    };
    return notificacaoSO;
};
export const filtrarAtrasosNaoLidos = (registros) => {
    if (!Array.isArray(registros)) {
        return [];
    }
    const alertas = registros.filter((item) => ehNotificacaoAlertaDescarga(item) && !item.Lida);
    return ordenarNotificacoesListagem(alertas);
};
export const obterLinkDestino = (notificacao) => {
    const dados = normalizarDadosAdicionais(notificacao);
    return dados?.link_destino || '/pages/descarga/descargas';
};
